import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth.service';

@Component({
  selector: 'app-clients-search-fields',
  templateUrl: './clients-search-fields.component.html',
  styleUrls: ['./clients-search-fields.component.css'],
})
export class ClientsSearchFieldsComponent implements OnInit {
  @Output() onSearch = new EventEmitter<Object>();
  @Output() onSearchSub = new EventEmitter<Object>();
  @Input() initialData: any;
  @Input() customerAllClients: boolean = false;
  currentUser;

  searchFields = [
    {
      fieldNumber: 0,
      fieldKey: 'name',
      fieldValue: '',
      button: 'add',
    },
  ];

  creditsOrder: string;
  creditsPaymentType: string;

  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    this.authService.LoggedinUser.subscribe((user) => {
      this.currentUser = user;
    });
    if(this.initialData) {
      Object.entries(this.initialData).forEach(([key, value]) => {
        if(`${key}` === 'paymentType') {
          this.creditsPaymentType = `${value}`
        } else if(`${key}` === 'creditsOrder') {
          this.creditsOrder = `${value}`
        } else {
          if(`${key}` === 'name') {
            this.searchFields = [
              {
                fieldNumber: 0,
                fieldKey: 'name',
                fieldValue: `${value}`,
                button: 'add',
              },
            ];
          } else {
            let data = {
              fieldNumber: 1,
              fieldKey: `${key}`,
              fieldValue: `${value}`,
              button: 'remove',
            };
            this.searchFields.push(data);
          }
        }
    });
    }
  }

  addField() {
    let data = {
      fieldNumber: 1,
      fieldKey: '',
      fieldValue: '',
      button: 'remove',
    };
    this.searchFields.push(data);
  }

  removeField(field) {
    if (this.searchFields.indexOf(field) != -1) {
      this.searchFields.splice(this.searchFields.indexOf(field), 1);
    }
  }

  creditsSort(type) {
    this.creditsOrder = type;
  }

  creditsType(type) {
    this.creditsPaymentType = type;
  }

  searchClients() {
    this.onSearch.emit(this.searchFields);
  }

  searchClientsbySubcustomer() {
    let searchFields = this.searchFields;
    let creditsPaymentType = this.creditsPaymentType;
    let creditsOrder = this.creditsOrder;
    this.onSearchSub.emit({
      searchFields,
      creditsPaymentType,
      creditsOrder,
    });
  }
}
